(function iife() {
	"use strict";

	angular.module("dx.webapp.student").directive("dxAbilityOverview", abilityOverviewDirective);

	function abilityOverviewDirective() {
		var directive = {
			restrict: "E",
			templateUrl: "tmpl/student/ability-overview-directive.html",
			scope: {
				studentId: "=",
				exams: "=",
			},
			controllerAs: "vm",
			controller: controller,
		};

		function controller(
			$scope,
			$rootScope,
			$filter,
			dxExam,
			dxDialog,
			examState,
			dxLocalize
		) {
			var self = this;

			self.uniqueMatrices = null;
			self.selectedMatrix = null;
			self.fullyLoadedExams = null;
			self.abilityQuestions = null;
			self.loading = false;

			self.previewGradingMatrix = function previewGradingMatrix(gradingMatrix) {
				var popupScope = $rootScope.$new();
				popupScope.matrix = gradingMatrix;
				dxDialog.show({
					templateUrl: "/partials/popups/view-grading-matrix.html",
					$scope: popupScope,
				});
			};

			$scope.$watch("vm.selectedMatrix", loadAbilityData);
			$scope.$watch("exams", prepareMatrices);

			function prepareMatrices() {
				self.uniqueMatrices = [];

				if ($scope.exams === null) {
					return;
				}

				for (var i = 0; i < $scope.exams.length; i++) {
					if ($scope.exams[i].gradingMatrix !== null) {
						var matrix = null;

						for (var j = 0; j < self.uniqueMatrices.length; j++) {
							if (self.uniqueMatrices[j].templateId === $scope.exams[i].gradingMatrix.templateId) {
								matrix = self.uniqueMatrices[j];
								break;
							}
						}

						if (matrix === null) {
							matrix = $scope.exams[i].gradingMatrix;
							matrix.examIds = [];
							self.uniqueMatrices.push(matrix);
						}

						matrix.examIds.push($scope.exams[i].id);
					}
				}
			}

			function loadAbilityData() {
				if (self.selectedMatrix === null) {
					return;
				}

				self.fullyLoadedExams = [];
				self.abilityQuestions = {};

				function onAllLoaded() {
					self.fullyLoadedExams = $filter("orderBy")(self.fullyLoadedExams, "start", false);

					for (var j = 0; j < self.selectedMatrix.abilities.length; j++) {
						var a = self.selectedMatrix.abilities[j];

						self.abilityQuestions[a.id] = questionsByAbilityId(a.id);
					}

					self.loading = false;
				}

				function onFullExamDataLoaded(res) {
					self.fullyLoadedExams.push(res);

					if (self.fullyLoadedExams.length === self.selectedMatrix.examIds.length) {
						onAllLoaded();
					}
				}

				self.loading = true;

				for (var i = 0; i < self.selectedMatrix.examIds.length; i++) {
					var eId = self.selectedMatrix.examIds[i];

					dxExam.report(eId, $scope.studentId).then(onFullExamDataLoaded);
				}
			}

			// questionsByAbilityId returns all questions for selected ability.
			// It attaches exam title and students grade to questions.
			function questionsByAbilityId(abilityId) {
				var questions = [];

				for (var i = 0; i < self.fullyLoadedExams.length; i++) {
					var e = self.fullyLoadedExams[i];

					for (var j = 0; j < e.questions.length; j++) {
						var question = e.questions[j];

						// It's important that we list each ability and question pair in the same order
						// as the abilities were defined when creating the grading matrix since that order
						// is used when grading.
						var matrixAbilities = self.selectedMatrix.abilities.filter(function filter(matrixAbility) { // eslint-disable-line no-loop-func
							return question.matrixAbilityMask.indexOf(matrixAbility.id) > -1;
						});

						var matrixAbilityIds = matrixAbilities.map(function map(matrixAbility) { // eslint-disable-line no-loop-func
							return matrixAbility.id;
						});

						var abilityIndex = matrixAbilityIds.indexOf(abilityId);

						if (abilityIndex > -1) {
							var questionCopy = angular.copy(question);
							questionCopy.examTitle = e.title;
							questionCopy.grade = getGradeTitle(e, self.selectedMatrix, j, abilityIndex);
							questions.push(questionCopy);
						}
					}
				}

				return questions;
			}

			function getGradeTitle(e, matrix, questionIndex, abilityIndex) {
				var grade = e.settings.student.answers[questionIndex].grade;

				if (e.settings.state !== examState.FINAL) {
					return dxLocalize.get("NotHandedIn");
				} else if (!grade || !grade.abilityGrades) {
					return dxLocalize.get("NotGraded");
				}

				var abilityGradeId = grade.abilityGrades[abilityIndex];

				if (abilityGradeId === -1) {
					return dxLocalize.get("NotGraded");
				}

				for (var i = 0; i < matrix.grades.length; i++) {
					if (matrix.grades[i].id === abilityGradeId) {
						return matrix.grades[i].title;
					}
				}

				return "-";
			}
		}

		return directive;
	}
}());
